import debounce from '../../helpers/debounce';

const DISABLED_CLASS = '-disabled';

export const initDevelopers = () => {
  const node = document.getElementById('premium-developers');
  if (!node) return;
  const arrowNext = node.querySelector('[data-next]');
  const arrowPrev = node.querySelector('[data-prev]');
  if (!arrowNext || !arrowPrev) return;
  let currentItemIndex = 0;
  const grid = node.querySelector('[data-grid]');
  const gridRect = grid.getBoundingClientRect();
  const items = [...node.querySelectorAll('[data-grid-item]')];

  const scrollListener = debounce(() => {
    const isAtRightEdge = Math.ceil(grid.scrollLeft + grid.clientWidth) >= grid.scrollWidth;

    if (isAtRightEdge) {
      currentItemIndex = items.length - 1;
    } else {
      currentItemIndex = items.findIndex((item) => {
        const rect = item.getBoundingClientRect();
        return rect.left >= gridRect.left && rect.right <= gridRect.right;
      })
    }

    if (currentItemIndex === 0) {
      arrowPrev.classList.add(DISABLED_CLASS);
    } else {
      arrowPrev.classList.remove(DISABLED_CLASS);
    }

    if (currentItemIndex === items.length - 1) {
      arrowNext.classList.add(DISABLED_CLASS);
    } else {
      arrowNext.classList.remove(DISABLED_CLASS);
    }
  }, 200);

  grid.addEventListener('scroll', scrollListener);

  const handleClick = (index) => {
    items[index].scrollIntoView({
      inline: 'center',
      block: 'nearest',
    });
  };

  arrowNext.addEventListener('click', () => {
    if (currentItemIndex === items.length - 1) return;
    handleClick(currentItemIndex + 1);
  });

  arrowPrev.addEventListener('click', () => {
    if (currentItemIndex === 0) return;
    handleClick(currentItemIndex - 1);
  });
};
